<template>
  <el-row class="tac">
    <el-col :span="12">
      <h5>平台接入</h5>
      <el-menu
        default-active="1-1"
        class="el-menu-vertical-demo"
        active-text-color="#0084FF"
        @open="handleOpen"
        @close="handleClose"
        background-color='#F8FBFD'
        :default-openeds='defaultOpeneds'
        :unique-opened="true"

      >
        <el-submenu index="1" class="ment">
          <template slot="title">
            <span style="margin-left:24px">数据传输及安全</span>
          </template>
          <el-menu-item-group style="border-left: 1px solid #f1f1f1;margin:12px 12px 24px 45px;">
            <el-menu-item index="1-1" @click="goTo('/documenta_1')" style="padding-left: 25px;">数据传输</el-menu-item>
            <el-menu-item index="1-2" @click="goTo('/documentb')" style="padding-left: 25px;">安全</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="2" class="ment">
          <template slot="title">
            <span style="margin-left:24px">桩站信息</span>
          </template>
          <el-menu-item-group style="border-left: 1px solid #f1f1f1;margin:12px 12px 24px 45px;">
            <el-menu-item index="2-1" @click="goTo('/documentc')">充电站信息</el-menu-item>
            <el-menu-item index="2-2" @click="goTo('/documentd')">充电设备信息</el-menu-item>
            <el-menu-item index="2-3" @click="goTo('/documente')">接口规范</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="3" class="ment">
          <template slot="title">
            <span style="margin-left:24px">交易流程</span>
          </template>
          <el-menu-item-group style="border-left: 1px solid #f1f1f1;margin:12px 12px 24px 45px;">
            <el-menu-item index="3-1" @click="goTo('/documentf')">交易流程</el-menu-item>
            <el-menu-item index="3-2" @click="goTo('/documentg')">对账和结算</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
  
      </el-menu>
    </el-col>
    <router-view></router-view>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      defaultOpeneds:['1']
    };
  },
  mounted(){
    this.goTo('/documenta_1')
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    goTo(path) {
      this.$router.replace(path);
    },
  },
};
</script>

<style scoped>
h5 {
  /* width: 306px; */
  height: 83px;
  /* background: #f2f7fb; */
  font-size: 22px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #191c27;
  line-height: 83px;
  text-align: left;
  margin-left:44px;
}
.el-col-12 {
 
  width: 306px;
  /* margin-top:40px; */
  background: #f8fbfd;
  text-align: left;
}
.ment {
  background: #f8fbfd;
}
.ment >>> .el-submenu__title {
  font-size: 18px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #191c27;
}
.ment >>> .el-menu-item-group__title{
  padding: 0px;
}
.ment >>> .el-menu-item:hover{
  background:  none!important;
  color: #0084FF;
}
.ment >>> .el-submenu__title:hover {
  background: none!important;
  color: #0084FF;
}
</style>


// WEBPACK FOOTER //
// src/components/ment.vue